import { db } from '../firebase'; // Adjust the path to your firebase.js file
import { collection, getDocs, addDoc, serverTimestamp, getDoc, doc } from "firebase/firestore";

const productService = {
  // 1. Fetch all products
  async getAllProducts() {
    try {
      const productsCol = collection(db, 'products');
      const productSnapshot = await getDocs(productsCol);
      const productList = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      return productList;
    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  },

  // 2. Fetch a single product by ID
  async getProductById(productId) {
    try {
      const productRef = doc(db, 'products', productId);
      const productSnap = await getDoc(productRef);
      if (productSnap.exists()) {
        return { id: productSnap.id, ...productSnap.data() };
      } else {
        return null;
      }
    } catch (error) {
      console.error(`Error fetching product ${productId}:`, error);
      return null;
    }
  },

  // 3. Add a new product
  async addProduct(productData) {
    try {
      const docRef = await addDoc(collection(db, "products"), {
        ...productData,
        createdAt: serverTimestamp(), // Optional: for tracking when it was added
      });
      return docRef.id;
    } catch (e) {
      console.error("Error adding document: ", e);
      return null;
    }
  },
  
};

export { productService };
